import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"

const AnjuIllustrationStatic = () => {
    return (
      <>
        <div class="masonry-wrap">
            <Masonry columnsCount={1} gutter={"0.75em"}>

            <div>
                    <a href="https://foundation.app/@ANJUonline/anju/3" target="_blank" rel="noopener noreferrer">
                        <img src="https://pbs.twimg.com/media/Fjy_P1KXkBY2AJc?format=jpg&name=large"/>
                        <p class="gallery-text">
                            <strong>"Don't By Shy"</strong><br/>
                            Cover art for <strong>ANJU Online! - Solid State Memories</strong><br/>
                            1/1 edition available on Foundation - 0.1 ETH
                        </p>
                    </a>
                </div>

                <div>
                    <a href="https://open.spotify.com/track/1OeOaYFIieCjVVn2Yl2Qxh?si=9f7847e58f6e4578" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/d97YdkH.jpg"/>
                        <p class="gallery-text">
                            Cover art for <strong>ANJU Online! & Kawaii Ry - Mr. Drill / pist off</strong>
                        </p>
                    </a>
                </div>

                <div>
                    <a href="https://foundation.app/@ANJUonline/anju/1" target="_blank" rel="noopener noreferrer">
                        <img src="https://f8n-production-collection-assets.imgix.net/0x1f597E08f4e7428845EB693d9F49B33f07eF04eD/1/nft.png?q=80&auto=format%2Ccompress&cs=srgb&max-w=1680&max-h=1680"/>
                        <p class="gallery-text">
                            <strong>"CC Plz 💞"</strong><br/>1/1 edition available on Foundation - 0.2 ETH
                        </p>
                    </a>
                </div>

                <div>
                        <img src="https://pbs.twimg.com/media/FRnSLHeXwAMvnoZ?format=jpg&name=4096x4096"/>
                        <p class="gallery-text">
                            <strong>"Self Care Night"</strong><br/>Private Commission
                        </p>
                </div>

                <div>
                    <a href="https://foundation.app/@ANJUonline/foundation/130357" target="_blank" rel="noopener noreferrer">
                        <img src="https://pbs.twimg.com/media/FATYxC0WEAUb4r1?format=jpg&name=large"/>
                        <p class="gallery-text">
                            <strong>"ANJUwu!"</strong><br/>1/1 edition available on Foundation - 0.1 ETH
                        </p>
                    </a>    
                </div>

                <div> 
                    <img src="https://i.imgur.com/FssODgS.jpeg"/>
                        <p class="gallery-text">
                        Cover art for my first album, <a href="https://open.spotify.com/album/0aHHZXbflT5Cznb2CEJw9T" target="_blank" rel="noopener noreferrer"><i>ANJU is Now Online!</i></a>
                        </p>
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/24" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/IIO7yUN.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"Fit Check"</strong><br/>2/30 editions available on Objkt - 0.9 XTZ
                        </p>
                    </a> 
                </div>

                <div>
                    <a href="https://foundation.app/@ANJUonline/anju/2" target="_blank" rel="noopener noreferrer">
                        <img src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/24b62acf-0cd7-4009-93ed-a0d140e5170d/deorpt1-a72d0361-b1b2-4533-954c-d4ffe385b912.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7InBhdGgiOiJcL2ZcLzI0YjYyYWNmLTBjZDctNDAwOS05M2VkLWEwZDE0MGU1MTcwZFwvZGVvcnB0MS1hNzJkMDM2MS1iMWIyLTQ1MzMtOTU0Yy1kNGZmZTM4NWI5MTIuanBnIn1dXSwiYXVkIjpbInVybjpzZXJ2aWNlOmZpbGUuZG93bmxvYWQiXX0.UlcHUb1ZfmpbhVLViu4AUHBccVZ4s10pHGn84xkQGwk"/>                  
                        <p class="gallery-text">
                            <strong>"Product Placement"</strong><br/>1/1 edition available on Foundation - 0.1 ETH
                        </p>
                    </a> 
                </div>

                <div>
                    <a href="https://versum.xyz/token/versum/6605" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/8X5hNZF.png"/>                  
                        <p class="gallery-text">
                            <strong>"Pixel Steppers"</strong><br/>5/5 editions available on Versum - 1 XTZ
                        </p>
                    </a> 
                </div>

                <div>
                        <img src="https://i.imgur.com/YpW8z2A.jpeg"/>                  
                        <p class="gallery-text">
                            Cover art for <strong>STARINTHESKY - DAMMIT</strong>
                        </p>
                </div>

                <div>
                        <img src="https://i.imgur.com/2bYy9ic.jpeg"/>                  
                        <p class="gallery-text">
                            Cover art for <strong>STARINTHESKY - FAST</strong>
                        </p>
                </div>

                <div>
                        <img src="https://i.imgur.com/ppN5sjY.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"Sore Loser"</strong>
                        </p>
                </div>

                <div>
                        <img src="https://i.imgur.com/j4XZtoj.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"Draw Anju in Your Style #1"</strong>
                        </p>
                </div>

                <div>
                        <img src="https://i.imgur.com/v0HeM5g.jpeg"/>                  
                        <p class="gallery-text">
                            Cover art for <strong>20MinsTillTokyo - White Tee</strong>
                        </p>
                </div>

                <div>
                        <img src="https://i.imgur.com/Vo1NK6F.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"Catch Me if You Can :)"</strong>
                        </p>
                </div>

                <div>
                        <img src="https://i.imgur.com/8Hp4GP8.jpeg"/>                  
                        <p class="gallery-text">
                            Cover art for <strong>ANJU Online! - Distracted / Active!</strong>
                        </p>
                </div>

                <div>
                        <img src="https://i.imgur.com/BapXfDc.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"Candy Break"</strong>
                        </p>
                </div>

                <div>
                        <img src="https://i.imgur.com/GlRLjhN.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"Security"</strong>
                        </p>
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/25" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/7IDSjbZ.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"Friend Request"</strong><br/>
                            1/10 editions available on Objkt - 1 XTZ
                        </p>
                    </a> 
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/17" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/X3KC0hL.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"Procrastination"</strong><br/>
                            10/20 editions available on Objkt - 0.8 XTZ
                        </p>
                    </a> 
                </div>

                <div>
                        <img src="https://i.imgur.com/VllNCwv.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"Open For Business"</strong><br/>
                        </p>
                </div>

                <div>
                        <img src="https://i.imgur.com/Z9JVWbo.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"Summer Days"</strong><br/>
                        </p>
                </div>

                <div>
                        <img src="https://i.imgur.com/ggKx9FK.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"Attachment"</strong><br/>
                        </p>
                </div>

                <div>
                        <img src="https://i.imgur.com/wDxXKAh.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"4AM Anxiety Bath"</strong><br/>
                        </p>
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/23" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/TpKsXp6.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"Almost Home"</strong><br/>
                            12/15 editions available on Objkt - 1 XTZ
                        </p>
                    </a> 
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/10" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/jDzjkr7.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"Missed Calls"</strong><br/>
                            6/13 editions available on Objkt - 1 XTZ
                        </p>
                    </a> 
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/21" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/1cjm1lq.png"/>                  
                        <p class="gallery-text">
                            <strong>"Fresh Air"</strong><br/>
                            6/15 editions available on Objkt - 0.8 XTZ
                        </p>
                    </a> 
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/18" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/cRqH6Vf.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"Good... For Now."</strong><br/>
                            1/20 editions available on Objkt - 0.8 XTZ
                        </p>
                    </a> 
                </div>

                <div>
                        <img src="https://i.imgur.com/64CZh8Y.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"Solitude"</strong><br/>
                        </p>
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/20" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/yxPX7Wt.png"/>                  
                        <p class="gallery-text">
                            <strong>"Sound Check"</strong><br/>
                            15/20 editions available on Objkt - 0.8 XTZ
                        </p>
                    </a> 
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/9" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/DWQNOGD.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"No Hands"</strong><br/>
                            15/19 editions available on Objkt - 0.8 XTZ
                        </p>
                    </a> 
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/8" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/EyXf2ZE.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"Bedford Station"</strong><br/>
                            3/9 editions available on Objkt - 0.69 XTZ
                        </p>
                    </a> 
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/13" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/xXfmz1h.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"We Need to Talk"</strong><br/>
                            9/20 editions available on Objkt - 0.69 XTZ
                        </p>
                    </a> 
                </div>

                <div>
                    <a href="https://opensea.io/assets/ethereum/0x495f947276749ce646f68ac8c248420045cb7b5e/70588876071654358432271143971228343612714605604690375153303570603557963956225" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/EwEerWO.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"Andromeda"</strong><br/>
                            1/1 owned by Gyvedd
                        </p>
                    </a> 
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/7" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/VrlMT9g.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"No Service"</strong><br/>
                            12/14 editions available on Objkt - 0.69 XTZ
                        </p>
                    </a> 
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/16" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/dbFW6b8.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"Logging In"</strong><br/>
                            9/20 editions available on Objkt - 0.8 XTZ
                        </p>
                    </a> 
                </div>

                <div>
                        <img src="https://i.imgur.com/i7iJUm5.jpeg"/>                  
                        <p class="gallery-text">
                            Tour poster for Nacho Picasso & Sadistik @ Strange Matter, Richmond VA (2017)
                        </p>
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/12" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/OxApZUB.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"Do Not Disturb"</strong><br/>
                            9/19 editions available on Objkt - 0.69 XTZ
                        </p>
                    </a> 
                </div>

                <div>
                        <img src="https://i.imgur.com/2MCH1Dm.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"Up in Smoke"</strong><br/>
                        </p>
                </div>

                <div>
                    <a href="https://objkt.com/asset/KT1DesRScqioLdizyRvsGyc9rkxh5qwtUcrZ/11" target="_blank" rel="noopener noreferrer">
                        <img src="https://i.imgur.com/7tL0IEb.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"Coffee Break"</strong><br/>
                            7/15 editions available on Objkt - 0.69 XTZ
                        </p>
                    </a> 
                </div>

                <div>
                        <img src="https://i.imgur.com/3Z8fPTs.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"I'm Gooood"</strong><br/>
                        </p>
                </div>

                <div>
                        <img src="https://i.imgur.com/YuoUGTs.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"SIGH"</strong><br/>
                        </p>
                </div>

                <div>
                        <img src="https://i.imgur.com/Evu0uuq.jpeg"/>                  
                        <p class="gallery-text">
                            <strong>"Nahhh"</strong><br/>
                        </p>
                </div>

                <div>
                        <img src="https://i.imgur.com/c4gZtB9.jpeg"/>                  
                        <p class="gallery-text">
                            Hollywood Cemetary - Richmond, VA<br/>
                        </p>
                </div>

            </Masonry>
        </div>      
      </>
    );
  };
  export default AnjuIllustrationStatic;